import { createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { class: "app-main" }, {
    default: _withCtx(() => [
      _createVNode($setup["PullToRefreshIndicator"]),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent($setup.layoutComponents[$setup.layout] || $setup.layoutComponents['auth-layout']), null, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1 /* STABLE */
          }))
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode($setup["SessionTimeoutModal"]),
      _createVNode($setup["ToastContainer"])
    ]),
    _: 1 /* STABLE */
  }))
}